<template>
  <div class="footer-container">
    <div class="footer clearfix">
      <div class="container clearfix">
        <div class="t1 showdiv">
          <div class="foot-logo">
            <table border="0" cellpadding="0" cellspacing="0">
              <tbody>
                <tr>
                  <td><img src="../../assets/hzvtc/common/hangzhixinlogo-baise-wangzhan.png" border="0"></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="links" @mouseleave="showList = false">
            <a @click="showList = !showList">友情链接<em></em></a>
            <ul id="selectList" v-show="showList" @mouseleave="showList = false">
              <li><a target="_blank" href="http://www.moe.gov.cn/">中华人民共和国教育部</a></li>
              <li><a target="_blank" href="http://www.tech.net.cn/">中国高职高专教育网</a></li>
              <li><a target="_blank" href="http://jyt.zj.gov.cn">浙江省教育厅</a></li>
              <li><a target="_blank" href="http://www.hangzhou.gov.cn/">中国杭州</a></li>
              <li><a target="_blank" href="http://edu.hangzhou.gov.cn/">杭州教育网</a></li>
              <li><a target="_blank" href="http://qt.hangzhou.gov.cn/">钱塘新区管理委员会</a></li>
            </ul>
          </div>
        </div>
        <div class="t2 showdiv">
          <p>地址：杭州下沙高教园区学源街68号</p>
          <p>电话：0571-56700055</p>
          <p>招生电话：0571-56700035 </p>
          <p>传真：0571-56700015</p>
        </div>
        <div class="t3 showdiv">
          <a href="javascript:void(0)"><img alt="" src="../../assets/hzvtc/common/gfxb20220915.jpg">
            <p>学院校报</p>
          </a>
          <a href="javascript:void(0)"><img alt="" src="../../assets/hzvtc/common/gfwb20220915.jpg">
            <p>官方微博</p>
          </a>
          <a href="javascript:void(0)"><img alt="" src="../../assets/hzvtc/common/gfwx20220915.jpg">
            <p>官方微信</p>
          </a>
        </div>
      </div>
      <div class="cory">
        <div class="container">
          <div class="bq ">
            <p>
              © 2003-2022 杭州职业技术学院 <a href="https://beian.miit.gov.cn/" target="_blank" style="color: rgba(255, 255, 255, 0.78);">浙ICP备05014570号-2</a>&nbsp;&nbsp;<a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33011802000748"
                target="_blank" style="color: rgba(255, 255, 255, 0.78);">浙公网安备 33011802000748</a>
            </p>
          </div>
          <div class="fw">
            <p>
              <!-- 您是第123位访客 -->
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      showList: false,
    }
  },
}
</script>

<style scoped>
.footer-container {
  height: 424px;
  margin-top: 10px;
  position: relative;
  z-index: 100;
  overflow: hidden;
}
.footer {
  background: url(../../assets/hzvtc/common/footer-bg.png) top center no-repeat;
  background-size: cover;
  padding: 200px 0 0;
  height: 100%;
}

.footer .t1 {
  float: left;
  position: relative;
  z-index: 9;
}

.footer .t2 {
  margin-left: 80px;
  float: left;
}

.footer .t2 p {
  color: rgba(255, 255, 255, 0.78);
  font-size: 0.875rem;
  line-height: 32px;
  text-align: left;
}

.footer .t3 {
  float: right;
}

.footer .t3 ul li {
  float: left;
  margin-left: 40px;
}

.footer .t3 ul li img {
  width: 90px;
  height: 90px;
}

.footer .t3 ul li p {
  color: rgba(255, 255, 255, 0.78);
  font-size: 0.875rem;
  text-align: center;
  padding: 10px 0;
}

.footer .t3 ul li:first-child {
  margin-left: 0;
}

.footer .t3 a {
  display: inline-block;
  margin-left: 40px;
}

.footer .t3 a img {
  width: 90px;
  height: 90px;
}

.footer .t3 a p {
  color: rgba(255, 255, 255, 0.78);
  font-size: 0.875rem;
  text-align: center;
  padding: 10px 0;
}

.footer .foot-logo img {
  width: 100%;
}

.footer .links {
  margin: 35px 0 0 68px;
  width: 180px;
  height: 30px;
  line-height: 30px;
  padding: 0 30px;
  border: 1px solid rgba(255, 255, 255, 0.78);
  position: relative;
  font-size: 0.875rem;
}

.footer .links a {
  color: rgba(255, 255, 255, 0.78);
  display: block;
}

.footer .links em {
  width: 12px;
  height: 6px;
  background: url(../../assets/hzvtc/common/select-ico.png) no-repeat;
  background-size: 100% 100%;
  position: absolute;
  right: 5px;
  top: 10px;
}

.footer .links ul {
  position: absolute;
  bottom: 102%;
  left: 0;
  width: 100%;
  padding: 0 10px 0 22px;
  background: #ad1e29;
}

.footer .cory {
  margin-top: 30px;
  padding: 14px 0 30px;
  /* border-top: 1px solid rgba(255, 255, 255, 0.15); */
}

.footer .cory p {
  color: rgba(255, 255, 255, 0.78);
  font-size: 0.875rem;
}

.footer .cory .bq {
  float: left;
}

.footer .cory .fw {
  float: right;
}
.container {
  width: 1400px;
  margin: 0 auto;
}
</style>